var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GoodsTip"},[_c('div',{staticClass:"GoodsTip-label"},[_c('div',{staticClass:"GoodsTip-label-text"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),_c('img',{attrs:{"src":require("../assets/images/tip.png")}})]),_vm._v(" "),_c('div',{staticClass:"GoodsTip-text"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/GoodsTip.vue